import PaymentProcessing from '@cont/Checkout/PaymentProcessing';
import Layout from '@layout/PaymentLayout/PaymentLayout';

const PaymentResponsePage = () => {
  return <PaymentProcessing />;
};

PaymentResponsePage.Layout = Layout;

PaymentResponsePage.pageInfo = {
  layoutOptions: {
    isCheckoutUrl: true,
    hideFooter: true,
    disableDarkMode: true,
    hideIntercom: true,
    hideFreshbot: true
  }
};

export default PaymentResponsePage;
